import { getDataClass, load } from 'scrivito'

export const getDataItemPromise = async (dataClassName: string, id: string) => {
  const dataClass = getDataClass(dataClassName)

  if (!dataClass) {
    return null
  }

  return load(() => (id && dataClass ? dataClass.get(id) : null)).catch(
    (error) => {
      console.log(error)
      return null
    },
  )
}
